import { Card, Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import "../../../../App.css";
import { RightCircleOutlined, LeftCircleOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import {
  SetTpvData,
  fetchTpvData,
  apiCallStatus,
} from "../actions/maintenanceDashboardService";
import {
  tpvstatusData,
  tpvDataLabels,
  barOptions,
  NCTableColumns,
  renderStatusData,
  handleBarClick,
} from "../constant/maintenanceConstantData";
import { TpvChildComponent } from "../maintenanceCommonComponent";

export default function ThirdPartyAuditCard({
  searchedItem,
  handleChevronRightClick,
  setShowThirdPartyAuditCard,
  showThirdPartyAuditCard,
}) {
  const dispatch = useDispatch();
  const [tpvValue, setTpvValue] = useState({
    tpvChartData: null,
    tpvTotalCount: 0,
    tpvModalData: null,
  });
  const maintenanceDashboardList = useSelector((state) => state?.maintenanceDashboardList);
  useEffect(() => {
    if (maintenanceDashboardList) {
      setTpvValue({
        tpvChartData: maintenanceDashboardList?.TpvChartData ,
        tpvTotalCount: maintenanceDashboardList?.TpvTotalCount ,
        tpvModalData: maintenanceDashboardList?.TpvModalData ,
      });
    }
  }, [maintenanceDashboardList]);

  // const {
  //   TpvChartData: tpvChartData,
  //   TpvTotalCount: tpvTotalCount,
  //   TpvModalData: tpvModalData,
  // } = useSelector((state) => state?.maintenanceDashboardList);

  //these are count
  const [openData, setOpenData] = useState(Array(0).fill(3));
  const [closedData, setCloseData] = useState(Array(0).fill(3));
  const [totalData, setTotalData] = useState(Array(0).fill(3));
  const [tpvModalVisible, setTpvModalVisible] = useState(false);
  const [tpvTotalCloseNcCount, setTpvTotalCloseNcCount] = useState(0);
  const [totalHighCount, setTotalHighCount] = useState(0);
  const [totalHighCloseCount, setTotalHighCloseCount] = useState(0);

  const [NCPageState, setNCPageState] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const ncPagination = {
    pageSize: NCPageState.pageSize, // Set the number of items per page
    current: NCPageState.currentPage, // Set the current page
    onChange: (page, pageSize) => {
      // Handle page change here, e.g., fetch and display data based on the new page and pageSize
      console.log(`Page: ${page}, PageSize: ${pageSize}`);
      setNCPageState({ currentPage: page, pageSize: pageSize });
    },
  };

  const tpvData = {
    labels: tpvDataLabels,
    datasets: [
      {
        label: tpvstatusData[0].status,
        data: openData,
        backgroundColor: tpvstatusData[0].color,
      },
      {
        label: tpvstatusData[1].status,
        data: closedData,
        backgroundColor: tpvstatusData[1].color,
      },
      {
        label: tpvstatusData[2].status,
        data: totalData,
        backgroundColor: tpvstatusData[2].color,
      },
    ],
  };
  const _doOpenTpvModal = () => {
    setTpvModalVisible(true);
  };
  const onClickHandler = handleBarClick(
    searchedItem,
    dispatch,
    fetchTpvData,
    _doOpenTpvModal
  );
  const tpvOptions = {
    ...barOptions,
    onClick: onClickHandler,
  };

  //view NC Table

  useEffect(() => {
    dispatch(SetTpvData({ tpvData }));
  }, [totalData]);

  useEffect(() => {
    if (tpvValue.tpvChartData) {
      const highOpen = filterData("HIGH", "OPEN")[0];
      const highClose = filterData("HIGH", "CLOSE")[0];
      const mediumOpen = filterData("MEDIUM", "OPEN")[0];
      const mediumClose = filterData("MEDIUM", "CLOSE")[0];
      const lowOpen = filterData("LOW", "OPEN")[0];
      const lowClose = filterData("LOW", "CLOSE")[0];
      setTpvTotalCloseNcCount(highClose + mediumClose + lowClose);

      setOpenData([highOpen, mediumOpen, lowOpen]);
      setCloseData([highClose, mediumClose, lowClose]);
      setTotalHighCount(highOpen + highClose);
      setTotalHighCloseCount(highClose);
      setTotalData([
        highOpen + highClose,
        mediumOpen + mediumClose,
        lowOpen + lowClose,
      ]);

      //set tpv score
      const tpvScore =
        tpvValue.tpvTotalCount !== 0
          ? (
              ((highClose + mediumClose + lowClose) / tpvValue.tpvTotalCount) *
              100
            ).toFixed(2) + "%"
          : "0.00%";
      dispatch(apiCallStatus({ tpvScore }));
    }
  }, [tpvValue.tpvChartData]);

  const filterData = (alertLevel, alertType) =>
    tpvValue.tpvChartData
      .filter(
        (item) =>
          item.alertLevel === alertLevel &&
          item.storeClosureUpdate === alertType
      )
      .map((item) => item.total);

  const _doCloseTpvModal = () => {
    setTpvModalVisible(false);
    setNCPageState((prevState) => ({ ...prevState, currentPage: 1 }));
  };
  const currentYear = searchedItem?.currentYear ?? new Date().getFullYear();
  return (
    <>
      <Modal
        open={tpvModalVisible}
        title="TPV NC List"
        width={1000}
        footer={[
          <button
            type="button"
            onClick={_doCloseTpvModal}
            className="btn muted-button  deca-btn-orange"
          >
            Close
          </button>,
        ]}
      >
        <div className="m-table__main">
          <div className="m-table__responsive large-width">
            <Table
              columns={NCTableColumns}
              dataSource={tpvValue.tpvModalData}
              pagination={ncPagination}
            />
          </div>
        </div>
      </Modal>
      <Card
        className={showThirdPartyAuditCard ? "first-card-class" : "card-class"}
      >
        <div className={showThirdPartyAuditCard ? "card-main-div" : ""}>
          <div className="card-first-div">
            <h3 className="card-heading">Third Party Audit</h3>
            <div className="chart-main-div">
              <div className="doughnut-chart-div">
                <Bar data={tpvData} options={tpvOptions} />
              </div>
              <div className="asset-health-score-level">
                {renderStatusData(tpvstatusData)}
              </div>
            </div>
            <div className="third-party-audit-icon-div">
              {showThirdPartyAuditCard ? (
                ""
              ) : (
                <span
                  onClick={() => {
                    handleChevronRightClick("third-party-audit");
                  }}
                  className="right-circle-outlined-icon"
                >
                  <RightCircleOutlined />
                </span>
              )}
            </div>
          </div>
          {showThirdPartyAuditCard && (
            <div className="showcard-card-class">
              <TpvChildComponent
                currentYear={currentYear}
                tpvTotalCount={tpvValue.tpvTotalCount}
                totalHighCount={totalHighCount}
                totalHighCloseCount={totalHighCloseCount}
                tpvTotalCloseNcCount={tpvTotalCloseNcCount}
              />
              <div className="third-party-audit-icon-div">
                <span
                  className="left-circle-outlined-icon"
                  onClick={() =>
                    setShowThirdPartyAuditCard(!showThirdPartyAuditCard)
                  }
                >
                  <LeftCircleOutlined />
                </span>
              </div>
            </div>
          )}
        </div>
      </Card>
    </>
  );
}
